//
// List Filter Controller
//
// Creates a filterable list from a list of elements
import { Controller } from '@hotwired/stimulus'
import List from 'list.js'

export default class ListFilterController extends Controller {
  static classes = ['search']

  static targets = ['list']

  static values = {
    fields: Array,
  }

  connect() {
    const filterableListOptions = {
      valueNames: this.fieldsValue,
      page: 20000,
      listClass: 'list', // This is the default class for the list
      searchClass: 'search', // This is the default class for the search input
    }

    // If we have a list target, use it
    // Otherwise, a child element with .list class will be used
    if (this.hasListTarget) {
      filterableListOptions.list = this.listTarget
    }

    this.list = new List(this.element, filterableListOptions)
  }
}
